export const steps = [
    {
        description: 'Sign In With\nSTEAM',
    },
    {
        description: 'Set STEAM Profile\nto Public',
    },
    {
        description: 'Enter\nGiveaway',
    },
];
